import { useContent } from '../../../../hooks/use-server-content';

export interface ImportantInfoAccordionProps {
    hide?: boolean;
    accordionTitle: string;
    accordionContent: string;
}
export const useImportantInfoAccordionContent = (
    componentName?: string,
    accordionContent?: string
): ImportantInfoAccordionProps | null => {
    const [content, getValueByName] = useContent(
        componentName || 'common',
        accordionContent || 'important-info-accordion'
    );

    let contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    if (contentFragment) {
        if (contentFragment.hide || !contentFragment.accordionTitle) {
            contentFragment = null;
        }
    }
    return contentFragment as ImportantInfoAccordionProps;
};
